// Typed path builders. Components never hardcode route strings —
// `navigate(paths.documentDetail(42))` instead of `navigate('/documents/42')`,
// so a route shape change is a one-file edit.
export const paths = {
  login: '/login',
  dashboard: '/',
  documents: '/documents',
  documentDetail: (id: number | string) => `/documents/${id}`,
  documentUpload: '/documents/upload',
  search: '/search',
  folder: (id: number | string) => `/folders/${id}`,
  approvals: '/approvals',
  digitization: '/digitization',
  digitizationCreateMaster: '/digitization/create-master',
  digitizationMasterDetail: (id: number | string) => `/digitization/master/${id}`,
  digitizationMasterStructure: (id: number | string) => `/digitization/master/${id}/structure`,
  qualityControl: '/digitization/qc',
  adminUsers: '/admin/users',
  adminUserCreate: '/admin/users/create',
  adminUserEdit: (id: number | string) => `/admin/users/${id}/edit`,
  adminRoles: '/admin/roles',
  adminRolePermissions: (id: number | string) => `/admin/roles/${id}/permissions`,
  adminDepartments: '/admin/departments',
  adminActionControl: '/admin/action-control',
  adminWorkflows: '/admin/workflows',
  adminWorkflowBuilder: (id: number | string) => `/admin/workflows/${id}`,
  adminAudit: '/admin/audit',
  adminTrash: '/admin/trash',
  settings: '/settings',
  profile: '/profile',
  forbidden: '/403',
  notFound: '/404',
} as const;
